'use client'

export const ProgressionBar = ({
  totalSteps,
  currentStep,
}: {
  totalSteps: number
  currentStep: number
}) => {
  return (
    <div className="mb-10 flex items-center justify-center mx-auto">
      {Array.from({ length: totalSteps }).map((_, i) => {
        const stepNumber = i + 1
        return (
          <div key={stepNumber} className="flex items-center">
            <div
              className={`h-5 w-5 md:h-8 md:w-8 rounded-full flex items-center justify-center text-sm font-bold transition-colors ${
                currentStep >= stepNumber ? 'bg-primary text-white' : 'bg-slate-200 text-slate-500'
              }`}
            >
              {stepNumber}
            </div>
            {stepNumber < totalSteps && (
              <div
                className={`h-1 w-6 md:w-10 ${currentStep > stepNumber ? 'bg-primary' : 'bg-slate-200'}`}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
